<template>
  <div class="">
    <!-- Header and Add Button -->
    <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-4 gap-4">
      <div class="flex items-center justify-center gap-1">
        <h2 class="text-xl font-semibold text-gray-800">List of users</h2>
        <a href="https://www.notion.so/UserProperty-03f3718085da48bc9cbdcca8872ff4d2" target="_blank">
          <span class="material-icons text-gray-400 hover:text-gray-600 mt-1" style="font-size: 20px" v-popover:tooltip="'Documentation'">info</span>
        </a>
      </div>
      <button
        @click="addingNewItem"
        class="flex items-center gap-2 bg-blue-800 hover:bg-blue-900 text-white font-semibold px-3 py-2 rounded-lg shadow transition"
      >
        <span class="material-icons text-base">add</span>
        Add User
      </button>
    </div>
    <!-- filters -->
    <div class="flex flex-wrap items-center justify-between gap-2 mb-4">
      <div class="flex bg-gray-200 rounded-lg">
        <button
          :class="[
            'px-4 py-2 font-medium focus:outline-none transition select-none',
            search.isVerified === '' ? 'bg-white text-indigo-700 font-semibold shadow-md rounded-lg z-10' : 'text-gray-600 hover:bg-gray-200',
          ]"
          @click="
            search.isVerified = '';
            fileter('', 'isVerified');
          "
        >
          All
        </button>
        <button
          :class="[
            'px-4 py-2 font-medium focus:outline-none transition select-none',
            search.isVerified === 'true' ? 'bg-white text-indigo-700 font-semibold shadow-md rounded-lg z-10' : 'text-gray-600 hover:bg-gray-200',
          ]"
          @click="
            search.isVerified = 'true';
            fileter('true', 'isVerified');
          "
        >
          Verified
        </button>
        <button
          :class="[
            'px-4 py-2 font-medium focus:outline-none transition select-none',
            search.isVerified === 'false' ? 'bg-white text-indigo-700 font-semibold shadow-md rounded-lg z-10' : 'text-gray-600 hover:bg-gray-200',
          ]"
          @click="
            search.isVerified = 'false';
            fileter('false', 'isVerified');
          "
        >
          Unverified
        </button>
      </div>
      <div class="flex items-center gap-2">
        <!-- language search -->
        <vs-select v-model="search.language" @change="fileter($event, 'language')" class="w-24" :color="'#6366f1'">
          <vs-select-item value="" text="All Languages" />
          <vs-select-item v-for="lang in languages" :key="lang.culture" :value="lang.culture" :text="lang.culture" />
        </vs-select>
        <!-- banned or not -->
        <vs-select v-model="search.isBanned" @change="fileter($event, 'isBanned')" class="w-28" :color="'#6366f1'">
          <vs-select-item value="" text="All Visibility" />
          <vs-select-item value="true" text="Banned" />
          <vs-select-item value="false" text="Not Banned" />
          <vs-select-item value="tobe" text="To be banned" />
        </vs-select>
        <!-- search key -->
        <vs-select @change="fileter($event, 'searchKey', false)" v-model="search.searchKey" class="w-32">
          <vs-select-item value text="Search On" />
          <vs-select-item value="userEmail" text="Email" />
          <vs-select-item value="userName" text="Username" />
          <vs-select-item value="androidVersion" text="Android version" />
          <vs-select-item value="iOsVersion" text="IOS version" />
          <vs-select-item value="userMob" text="Mobile Number" />
        </vs-select>
        <!-- search field -->
        <div>
          <vs-input v-model="searchValue" @keyup.enter="fetchAllUsers()" id="search" type="text" label-placeholder="Search value..." class="w-48" />
        </div>
        <!-- buttons -->
        <div class="flex items-center gap-2">
          <button
            @click="fetchAllUsers()"
            class="flex items-center gap-1 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg font-medium transition"
          >
            <span class="material-icons text-base">search</span> Search
          </button>
          <button
            @click="resetData()"
            class="flex items-center gap-1 bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded-lg font-medium transition"
          >
            <span class="material-icons text-base">refresh</span> Reset
          </button>
        </div>
      </div>
    </div>
    <!-- Table -->
    <div class="overflow-x-auto rounded-xl border border-gray-200 bg-white pb-2">
      <table class="min-w-full bg-white rounded-xl">
        <thead class="border-b">
          <tr>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">#</th>
            <th class="px-4 py-3"></th>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">Name</th>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">Username</th>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">Contact Info</th>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">Language</th>
            <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase">Status</th>
            <th class="px-4 py-3"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, idx) in all" :key="item._id" class="border-b hover:bg-gray-100 transition">
            <td class="px-4 py-3 text-sm text-gray-700">{{ idx + 1 + pagination.per_page * (pagination.current_page - 1) }}</td>
            <td class="px-4 py-2">
              <img :src="item.imageURL || require('@/assets/images/No-image.png')" alt="Event Thumbnail" class="w-16 h-16 object-cover rounded-lg" />
            </td>
            <td class="px-4 py-3 text-sm text-gray-700">
              <div class="flex flex-col gap-1">
                <span>{{ item.firstName ? item.firstName + " " + item.lastName : "N/A" }}</span>
                <span
                  v-if="item.vipUser"
                  :class="'bg-gray-200 text-gray-500'"
                  class="inline-block px-3 py-1 rounded-full font-semibold"
                  style="width: 5.5rem"
                >
                  VIP User
                </span>
              </div>
            </td>
            <td class="px-4 py-3 text-sm text-gray-700 w-80" :title="item.userName ? '' : 'Generated Username only for display (not stored)'">
              {{ item.userName ? item.userName : `guest-${Math.random().toString(36).substring(2, 8)}` }}
            </td>
            <td class="px-4 py-3 text-sm text-gray-700">
              <div class="flex flex-col gap-1">
                <span v-if="item.userEmail">Email: {{ item.userEmail }}</span>
                <span v-if="item.userMob">Phone: {{ item.userMob }}</span>
                <span v-if="!item.userEmail && !item.userMob">N/A</span>
              </div>
            </td>
            <td class="px-4 py-3 text-sm text-gray-700">{{ item.language }}</td>
            <td class="px-4 py-3 text-sm text-gray-700 text-center">
              <div class="flex flex-col gap-1">
                <span
                  :class="item.isVerified ? 'bg-green-200 text-green-600' : 'bg-yellow-300 text-yellow-800'"
                  class="inline-block px-3 py-1 rounded-full font-semibold"
                >
                  {{ item.isVerified ? "Verified" : "Unverified" }}
                </span>
                <span
                  :class="item.isBanned ? 'bg-red-200 text-red-600' : 'bg-green-200 text-green-600'"
                  class="inline-block px-3 py-1 rounded-full font-semibold"
                >
                  {{ item.isBanned ? "Banned" : "Active" }}
                </span>
                <span v-if="item.strikes && item.strikes > 0" class="bg-yellow-200 text-yellow-600 inline-block px-3 py-1 rounded-full font-semibold">
                  Strikes: {{ item.strikes }}
                </span>
                <span v-if="item.isPrivateProfile" class="bg-gray-200 text-gray-500 inline-block px-3 py-1 rounded-full font-semibold">
                  Private
                </span>
              </div>
            </td>
            <td class="px-4 py-1">
              <vs-dropdown>
                <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <circle cx="12" cy="5" r="1.5" />
                  <circle cx="12" cy="12" r="1.5" />
                  <circle cx="12" cy="19" r="1.5" />
                </svg>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="editingItem(item)"> <vs-icon icon="create" class="align-right" /> Edit </vs-dropdown-item>
                  <vs-dropdown-item
                    @click="
                      deleteEventPopup = true;
                      itemToDelete = item;
                    "
                  >
                    <vs-icon icon="delete_sweep" /> Delete
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    @click="
                      viewUserPopup = true;
                      itemToView = item;
                      fetchAllEvents();
                      invitedUsers();
                    "
                  >
                    <vs-icon icon="visibility" class="align-right" /> View Profile
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    v-if="!item.isBanned"
                    @click="
                      usertoBan = item;
                      banUserPopup = true;
                    "
                  >
                    <vs-icon icon="block" class="align-right" /> Ban User
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </td>
          </tr>
          <tr v-if="!all || all.length === 0">
            <td colspan="8" class="px-4 py-3 text-center text-gray-500">No users found.</td>
          </tr>
        </tbody>
      </table>
      <!-- pagination -->
      <div class="flex flex-col md:flex-row items-center justify-between mt-3 pr-3" v-if="pagination && pagination.total_pages > 1">
        <div class="invisible">
          <span>asd</span>
        </div>
        <div class="flex justify-center items-center">
          <vs-pagination v-model="pagination.current_page" :total="pagination.total_pages" :limit="1" @change="fetchAllUsers" class="my-2" />
        </div>
        <div class="flex items-center gap-2 text-sm mt-2 md:mt-0">
          <span>Show Records:</span>
          <vs-select v-model="pagination.per_page" @change="fetchAllUsers(1)" class="w-20" :color="'#6366f1'">
            <vs-select-item value="10" text="10" />
            <vs-select-item value="25" text="25" />
            <vs-select-item value="50" text="50" />
          </vs-select>
        </div>
      </div>
    </div>

    <!-- add/edit user -->
    <vs-popup :title="isNew ? 'Add New User' : 'Edit User'" :active.sync="defaultalert">
      <div class="px-2 flex flex-col gap-1">
        <div class="w-1/4 mb-2">
          <label class="block text-sm font-semibold mb-2">Language</label>
          <vs-select v-model="user.language" class="w-full" :color="'#6366f1'" :disabled="showLoader">
            <vs-select-item value="" text="Select Language" disabled />
            <vs-select-item v-for="lang in languages" :key="lang.culture" :value="lang.culture" :text="lang.culture" />
          </vs-select>
        </div>
        <!-- flexed boxed firstname and last name -->
        <div class="flex justify-between gap-2">
          <div class="w-1/2">
            <label class="block text-sm font-semibold mb-2">First Name</label>
            <vs-input v-model="user.firstName" placeholder="Keep short and simple" class="w-full" required :disabled="showLoader" />
          </div>
          <div class="w-1/2">
            <label class="block text-sm font-semibold mb-2">Last Name</label>
            <vs-input v-model="user.lastName" placeholder="Keep short and simple" class="w-full" required :disabled="showLoader" />
          </div>
        </div>
        <!-- flexed boxed number and email -->
        <div class="flex justify-between gap-2">
          <div class="w-1/2">
            <label class="block text-sm font-semibold mb-2">Mobile Number</label>
            <vs-input v-model="user.userMob" placeholder="Enter mobile number" class="w-full" required :disabled="showLoader" />
          </div>
          <div class="w-1/2">
            <label class="block text-sm font-semibold mb-2">Email</label>
            <vs-input v-model="user.userEmail" placeholder="Enter email" class="w-full" required :disabled="showLoader" />
          </div>
        </div>
        <!-- flexed boxed image url and username -->
        <div class="flex justify-between gap-2">
          <div class="w-1/2">
            <label class="block text-sm font-semibold mb-2">Image URL</label>
            <vs-input v-model="user.imageURL" placeholder="Enter image URL" class="w-full" required :disabled="showLoader" />
          </div>
          <div class="w-1/2">
            <label class="block text-sm font-semibold mb-2">Username</label>
            <vs-input v-model="user.userName" placeholder="Enter username" class="w-full" required :disabled="showLoader" />
          </div>
        </div>
        <!-- flexed boxed city and country -->
        <div class="flex justify-between gap-2">
          <div class="w-1/2">
            <label class="block text-sm font-semibold mb-2">City</label>
            <vs-input v-model="user.city" placeholder="Enter city" class="w-full" required :disabled="showLoader" />
          </div>
        </div>
        <!-- flexed boxed lat and lang -->
        <div class="flex justify-between gap-2">
          <div class="w-1/2">
            <label class="block text-sm font-semibold mb-2">Latitude</label>
            <vs-input v-model="user.location.coordinates[0]" placeholder="Enter latitude" class="w-full" required :disabled="showLoader" />
          </div>
          <div class="w-1/2">
            <label class="block text-sm font-semibold mb-2">Longitude</label>
            <vs-input v-model="user.location.coordinates[1]" placeholder="Enter longitude" class="w-full" required :disabled="showLoader" />
          </div>
        </div>
        <!-- flexed boxed joining date and facebookid -->
        <div class="flex justify-between gap-2">
          <div class="w-1/2">
            <label class="block text-sm font-semibold mb-2">Joining Date</label>
            <datepicker
              placeholder="Joining Date"
              v-model="user.joinDate"
              id="start_date"
              format="yyyy-MM-dd"
              input-class="border"
              :open-date="new Date()"
              @selected="dateSelected($event)"
            ></datepicker>
          </div>
          <div class="w-1/2">
            <label class="block text-sm font-semibold mb-2">Facebook ID</label>
            <vs-input v-model="user.facebookId" placeholder="Enter Facebook ID" class="w-full" required :disabled="showLoader" />
          </div>
        </div>
        <!-- toggle pills of vipuser, banned,verified,private -->
        <div class="flex justify-between w-full gap-1">
          <div class="w-1/2">
            <label class="block text-sm font-semibold mb-2">VIP</label>
            <toggle-pill label="VIP" v-model="user.vipUser" />
          </div>
          <div class="w-1/2">
            <label class="block text-sm font-semibold mb-2">Banned</label>
            <toggle-pill label="Banned" v-model="user.isBanned" />
          </div>
          <div class="w-1/2">
            <label class="block text-sm font-semibold mb-2">Verified</label>
            <toggle-pill label="Verified" v-model="user.isVerified" />
          </div>
          <div class="w-1/2">
            <label class="block text-sm font-semibold mb-2">Private</label>
            <toggle-pill label="Private" v-model="user.isPrivateProfile" />
          </div>
        </div>
        <div class="flex flex-col md:flex-row gap-2 mt-2">
          <vs-button :loading="showLoader" color="primary" type="filled" class="flex-1" @click="btnAddUser">
            {{ isNew ? "Save User" : "Update User" }}
          </vs-button>
        </div>
      </div>
    </vs-popup>

    <!-- profile view -->
    <vs-popup class="holamundo user-info" title="View User" :active.sync="viewUserPopup" fullscreen>
      <vs-row>
        <vs-col vs-lg="6" vs-xs="6">
          User Information
          <div class="mt-4">
            <img v-if="itemToView.imageURL == '' || itemToView.imageURL == null" src="@/assets/images/No-image.png" height="50px" width="75px" />
            <img v-else :src="itemToView.imageURL" height="50px" width="75px" />
            <br />
            <label>{{ itemToView.userName }}</label>
            <br />
            <label>{{ itemToView.firstName }} {{ itemToView.lastName }}</label>
            <br />
            <label>FacebookId : {{ itemToView.facebookId }}</label>
            <br />
            <label>Mobile Number : {{ itemToView.userMob }}</label>
            <br />
            <label>Email : {{ itemToView.userEmail }}</label>
            <br />
          </div>
        </vs-col>
        <vs-col vs-lg="6" vs-xs="6">
          User Address
          <div class="mt-4">
            <label>City : {{ itemToView.city }}</label>
            <br />
            <label>Country : {{ itemToView.country }}</label>
            <br />
            <label> Birth Date :{{ new Date(itemToView.birthday).toLocaleString() }} </label>
            <br />
            <label>isBanned : {{ itemToView.isBanned }}</label>
            <br />
            <label>isVerified : {{ itemToView.isVerified }}</label>
            <br />
            <label>isPrivateProfile : {{ itemToView.isPrivateProfile }}</label>
            <br />
            <label>VIP User : {{ itemToView.vipUser }}</label>
          </div>
        </vs-col>
      </vs-row>
      <hr />
      <div class="flex items-center justify-end w-full gap-2">
        <vs-select @change="findEvent($event)" v-model="search.findEvent" class="w-32">
          <vs-select-item value="created" text="Created" />
          <vs-select-item value="invited" text="Invited" />
          <vs-select-item value="attending" text="Attending" />
          <vs-select-item value="not attending" text="Not Attending" />
          <vs-select-item value="may be attending" text="May be attending" />
        </vs-select>
        <vs-button class="ml-auto mt-3 mb-3" type="filled" icon="add_circle" size="small" @click="addNewEvent">Add New Event</vs-button>
      </div>
      <div class="overflow-x-auto rounded-xl border border-gray-200 bg-white pb-2">
        <table class="min-w-full bg-white rounded-xl">
          <thead class="border-b">
            <tr>
              <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">#</th>
              <th class="px-4 py-3"></th>
              <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">Title</th>
              <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase">Language</th>
              <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase">Extra Info</th>
              <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase">Status</th>
              <th class="px-4 py-3 text-xs text-center font-semibold text-gray-500 uppercase">Creation Date</th>
              <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">Start/End Time</th>
              <th class="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) in events" :key="item._id" class="border-b hover:bg-gray-100 transition">
              <td class="px-4 py-3 text-sm text-gray-700">{{ idx + 1 }}</td>
              <td class="px-4 py-2">
                <img
                  :src="item.imageURL || require('@/assets/images/No-image.png')"
                  alt="Event Thumbnail"
                  class="w-28 h-16 object-cover rounded-lg"
                />
              </td>
              <td class="px-4 py-3 text-sm text-gray-700">{{ item.title }}</td>
              <td class="px-4 py-3 text-sm text-gray-700 text-center">{{ item.language }}</td>
              <!-- invited/attending info -->
              <td class="px-4 py-3 text-sm text-gray-700 text-center">
                <div class="flex flex-col gap-1">
                  <span>Invited: {{ item.invited }}</span>
                  <span>Attending: {{ item.attending }}</span>
                  <span>Not Attending: {{ item.notAttending }}</span>
                  <span>May be Attending: {{ item.mayBeAttending }}</span>
                </div>
              </td>
              <td class="px-4 py-1 text-center">
                <div class="flex flex-col gap-2">
                  <!-- approval status -->
                  <span
                    :class="
                      item.eventStatus === 'APPROVED'
                        ? 'bg-green-500 text-white'
                        : item.eventStatus === 'PENDING'
                        ? 'bg-yellow-500 text-white'
                        : 'bg-gray-200 text-gray-500'
                    "
                    class="inline-block px-3 py-1 rounded-full font-semibold"
                  >
                    {{ item.eventStatus }}
                  </span>
                  <!-- private/public status -->
                  <span
                    :class="item.isPrivate ? 'bg-red-500 text-white' : 'bg-blue-500 text-white'"
                    class="inline-block px-3 py-1 rounded-full font-semibold"
                  >
                    {{ item.isPrivate ? "Private" : "Public" }}
                  </span>
                </div>
              </td>
              <td class="px-4 py-3 text-sm text-gray-700 text-center">{{ formatDate(item.createdAt) }}</td>
              <td class="px-4 py-3 text-sm text-gray-700">
                <div class="flex flex-col gap-1">
                  <span>Start: {{ formatDate(item.startDate) }} at {{ item.startTime }}</span>
                  <span>End: {{ formatDate(item.endDate) }} at {{ item.endTime }}</span>
                </div>
              </td>
              <td class="px-4 py-1">
                <vs-dropdown>
                  <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <circle cx="12" cy="5" r="1.5" />
                    <circle cx="12" cy="12" r="1.5" />
                    <circle cx="12" cy="19" r="1.5" />
                  </svg>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="editingEvent(item)"> <vs-icon icon="create" class="align-right" /> Edit </vs-dropdown-item>
                    <vs-dropdown-item
                      @click="
                        eventToDelete = item;
                        viewUserPopup = false;
                        deleteEventPopup = true;
                      "
                    >
                      <vs-icon icon="delete_sweep" /> Delete
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </td>
            </tr>
            <tr v-if="!all || all.length === 0">
              <td colspan="12" class="text-center h-full py-6 text-gray-400">No events found.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </vs-popup>

    <!-- add/edit event -->
    <vs-popup :title="newEvent ? 'Add New Event' : 'Edit Event'" class="holamundo modalOpenCss" :active.sync="eventModal" @close="addEvent()">
      <div class="px-2 flex flex-col gap-1">
        <!-- category selection -->
        <div class="w-1/4">
          <label class="block text-sm font-semibold mb-2"> Category*</label>
          <vs-select v-model="event.categoryId" :color="'#6366f1'">
            <vs-select-item :key="index" :value="item._id" :text="item.categoryName" v-for="(item, index) in categories" />
          </vs-select>
        </div>
        <!-- event title -->
        <label class="block text-sm font-semibold">Event Title*</label>
        <vs-input v-model="event.title" placeholder="Keep short and simple" class="w-full" required />
        <!-- event description -->
        <label class="block text-sm font-semibold">Event Description*</label>
        <vs-textarea v-model="event.description" placeholder="Keep short and simple" class="w-full" required />
        <!-- event image upload -->
        <div class="flex-1" style="height: 150px">
          <div class="flex justify-between items-start">
            <label class="block text-sm font-semibold">Image</label>
            <button
              v-if="displayImage"
              type="button"
              color="danger"
              class="bg-red-500 p-1 h-6 rounded-md hover:bg-red-700 transition text-white"
              @click="clearImage"
            >
              Clear
            </button>
          </div>
          <div
            class="flex flex-col items-center justify-center border-2 border-dashed rounded-md cursor-pointer bg-gray-50 hover:bg-gray-100 transition"
            style="width: 100%; height: 140px; min-height: 140px"
            @dragover.prevent
            @dragenter.prevent
            @drop.prevent="onDropImage"
            @click="triggerFileInput"
          >
            <img v-if="displayImage" :src="displayImage" class="rounded-md object-cover border" style="width: 200px; max-height: 140px" />
            <div v-else class="flex flex-col items-center justify-center w-full h-full text-gray-400">
              <span class="material-icons" style="font-size: 32px">cloud_upload</span>
              <span>Drag & Drop or Click to Upload</span>
            </div>
            <input type="file" ref="fileInput" class="hidden" @change="onImageChange" accept="image/jpeg,image/jpg,image/webp" />
          </div>
        </div>
        <!-- flex boxed phone + user email -->
        <div class="flex justify-between w-full gap-2 mt-2">
          <div class="w-1/2">
            <label class="block text-sm font-semibold">User Email*</label>
            <vs-input v-model="event.email" placeholder="Enter user email" class="w-full" required />
          </div>
          <div class="w-1/2">
            <label class="block text-sm font-semibold">Phone*</label>
            <vs-input v-model="event.phone" placeholder="Enter phone number" class="w-full" required />
          </div>
        </div>
        <!-- address -->
        <label class="block text-sm font-semibold">Event Address</label>
        <!-- <vue-google-autocomplete
          id="map"
          class="w-full"
          placeholder="Start typing to search for address"
          :types="['address']"
          :country="['in']"
          @placechanged="getAddressData"
        /> -->
        <vs-input v-model="event.address" placeholder="Enter event address" class="w-full" required />
        <!-- flexed boxed city + taluka -->
        <div class="flex justify-between w-full gap-2">
          <div class="w-1/2">
            <label class="block text-sm font-semibold">City*</label>
            <vs-input v-model="event.city" placeholder="Enter city" class="w-full" required />
          </div>
          <div class="w-1/2">
            <label class="block text-sm font-semibold">District*</label>
            <vs-input v-model="event.districtName" placeholder="Enter district" class="w-full" required />
          </div>
        </div>
        <!-- flexed boxed district +  state -->
        <div class="flex justify-between w-full gap-2">
          <div class="w-1/2">
            <label class="block text-sm font-semibold">Taluk*</label>
            <vs-input v-model="event.talukName" placeholder="Enter taluk" class="w-full" required />
          </div>
          <!-- <div class="w-1/2">
            <label class="block text-sm font-semibold">Country*</label>
            <vs-input v-model="event.country" placeholder="Enter country" class="w-full" required />
          </div> -->
          <div class="w-1/2">
            <label class="block text-sm font-semibold">Duration*</label>
            <vs-input v-model="event.duration" placeholder="Enter duration" class="w-full" required />
          </div>
        </div>
        <!-- flexed boxed pincode + user limit -->
        <div class="flex justify-between w-full gap-2">
          <div class="w-1/2">
            <label class="block text-sm font-semibold">Pincode*</label>
            <vs-input v-model="event.pincode" placeholder="Enter pincode" class="w-full" required />
          </div>
          <div class="w-1/2">
            <label class="block text-sm font-semibold">User Limit*</label>
            <vs-input v-model="event.userLimit" placeholder="Enter user limit" class="w-full" required type="number" :min="1" />
          </div>
        </div>
        <!-- flexed boxed latitude + longitude  -->
        <div class="flex justify-between w-full gap-2">
          <div class="w-1/2">
            <label class="block text-sm font-semibold">Latitude*</label>
            <vs-input v-model="event.location.coordinates[0]" placeholder="Enter latitude" class="w-full" required />
          </div>
          <div class="w-1/2">
            <label class="block text-sm font-semibold">Longitude*</label>
            <vs-input v-model="event.location.coordinates[1]" placeholder="Enter longitude" class="w-full" required />
          </div>
        </div>
        <!-- flexed date in -->
        <div class="flex justify-between w-full gap-2">
          <div class="w-full">
            <label class="block text-sm font-semibold">Start Date*</label>
            <datepicker v-model="event.startDate" :format="'yyyy/MM/dd'" class="w-full" required />
          </div>
          <div class="w-full">
            <label class="block text-sm font-semibold">End Date*</label>
            <datepicker v-model="event.endDate" :format="'yyyy/MM/dd'" class="w-full" required />
          </div>
        </div>
        <!-- flexed time in -->
        <div class="flex justify-between w-full gap-2">
          <div class="w-full">
            <label class="block text-sm font-semibold">Start Time*</label>
            <vue-timepicker v-model="event.startTime" format="HH:mm" class="w-full" required />
          </div>
          <div class="w-full">
            <label class="block text-sm font-semibold">End Time*</label>
            <vue-timepicker v-model="event.endTime" format="HH:mm" class="w-full" required />
          </div>
        </div>
        <!-- flexed boxed in one row recurring, feature event, private, status togglepills -->
        <div class="flex items-center justify-center w-full gap-10">
          <div class="">
            <label class="block text-sm font-semibold mb-2">Private</label>
            <toggle-pill label="Private" v-model="event.isPrivate" />
          </div>
          <div class="">
            <label class="block text-sm font-semibold mb-2">Status</label>
            <toggle-pill label="Status (Active/Inactive)" v-model="event.status" />
          </div>
        </div>
        <!-- if feature event  show flexed boxed alltime + district + taluk + town-->
        <div class="flex justify-between w-full gap-1" v-if="event.feature">
          <div class="w-1/2">
            <label class="block text-sm font-semibold mb-2">All Time</label>
            <toggle-pill label="All Time" v-model="event.alltime" />
          </div>
          <div class="w-1/2">
            <label class="block text-sm font-semibold mb-2">District</label>
            <toggle-pill label="District" v-model="event.district" />
          </div>
          <div class="w-1/2">
            <label class="block text-sm font-semibold mb-2">Taluk</label>
            <toggle-pill label="Taluk" v-model="event.taluk" />
          </div>
          <div class="w-1/2">
            <label class="block text-sm font-semibold mb-2">Town</label>
            <toggle-pill label="Town" v-model="event.town" />
          </div>
        </div>
        <!-- enter mobile numbers with commas -->
        <label class="block text-sm font-semibold">Invite Users (Mobile Numbers with commas)</label>
        <vs-textarea v-model="event.mobiles" placeholder="Enter mobile numbers separated by commas" class="w-full" />
        <!-- enter email addresses with commas -->
        <label class="block text-sm font-semibold">Invite Users (Email Addresses with commas)</label>
        <vs-textarea v-model="event.emails" placeholder="Enter email addresses separated by commas" class="w-full" />
        <!-- select users to invite -->
        <label class="block text-sm font-semibold">Select Users to Invite</label>
        <multiselect
          v-model="event.users"
          :options="userFollowers"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Select users"
          label="userName"
          track-by="_id"
          class="w-full"
        ></multiselect>

        <!-- attachment  -->
        <div class="upload-btn-wrapper vs-input-primary">
          <label class="vs-input--label">Attachment</label>
          <div class="btn"><vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload an Attachment File</div>
          <input type="file" ref="fileInput2" @change="uploadImage($event, true)" />
        </div>
        <!-- attachments -->
        <div class="mr-2" v-for="(url, index) in event.attachments" :key="index" v-if="event.attachments.length > 0">
          <vs-button color="danger" type="flat" icon="clear" class="closeBtn" @click="deleteattachmentImage(index)"></vs-button>
          <img
            :src="url.fileurl"
            class="imgUp"
            height="100px"
            width="150px"
            v-if="url.filetype == 'image/jpeg' || url.filetype == 'image/png' || url.filetype == 'image/jpg'"
          />
          <vs-icon icon="assignment" @click="openDoc(url.fileurl)" v-if="url.filetype == 'application/pdf'" class="icon-medium pointer"> </vs-icon>
          <audio controls v-if="url.filetype == 'audio/mpeg'">
            <source :src="url.url" type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
        </div>
      </div>
      <div class="flex flex-col md:flex-row gap-2 mt-8">
        <vs-button :loading="showLoader" color="primary" type="filled" class="flex-1" @click="btnAddEvent">
          {{ isNew ? "Save Event" : "Update Event" }}
        </vs-button>
      </div>
    </vs-popup>

    <!-- delete popup -->
    <vs-popup title="Delete Event" :active.sync="deleteUserPopup">
      <p class="mb-4 text-lg text-gray-700">Are you sure you want to delete this event?</p>
      <div class="flex justify-end gap-2">
        <vs-button color="warning" @click="deleteUser">Delete</vs-button>
        <vs-button color="primary" @click="deleteUserPopup = false">Cancel</vs-button>
      </div>
    </vs-popup>

    <!-- Delete event Popup -->
    <vs-popup
      title="Delete Event"
      :active.sync="deleteEventPopup"
      @close="
        eventToDelete = '';
        addEvent();
      "
    >
      <p class="mb-4 text-lg text-gray-700">Are you sure you want to delete this event?</p>
      <div class="flex justify-end gap-2">
        <vs-button color="warning" @click="deleteEvent">Delete</vs-button>
        <vs-button
          color="primary"
          @click="
            deleteEventPopup = false;
            eventToDelete = '';
            addEvent();
          "
          >Cancel</vs-button
        >
      </div>
    </vs-popup>

    <!-- ban confirm popup -->
    <vs-popup title="Ban User" :active.sync="banUserPopup">
      <p class="mb-4 text-lg text-gray-700">Are you sure you want to ban {{ user.firstName }} {{ user.lastName }}?</p>
      <div class="flex justify-end gap-2">
        <vs-button color="warning" @click="btnUpdateUser(true)">Ban</vs-button>
        <vs-button color="primary" @click="banUserPopup = false">Cancel</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import api from "@/rest.js";
import Datepicker from "vuejs-datepicker";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import { API } from "@/common/constants";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import Multiselect from "vue-multiselect";
import moment from "moment";
import TogglePill from "../components/Common/TogglePill.vue";

export default {
  name: "Users",
  components: {
    Datepicker,
    VueTimepicker,
    VueGoogleAutocomplete,
    Multiselect,
    TogglePill,
  },
  data: () => ({
    viewPopup: false,
    all: [],
    events: [],
    categories: [],
    addAdmin: false,
    searchValue: "",
    fileName: "",
    languages: [],
    translatedTithis: [],
    translatedSuryanakshatras: [],
    userFollowers: [],
    isNew: true,
    defaultalert: false,
    deleteUserPopup: false,
    viewUserPopup: false,
    banUserPopup: false,
    deleteEventPopup: false,
    eventModal: false,
    newEvent: false,
    pagination: {
      current_page: 1,
      per_page: 10,
      total_count: 0,
      total_pages: 1,
    },
    currentPage: 1,
    pageSize: 10,
    totalPages: 1,
    showLoader: false,
    search: {
      sort: 1,
      // language: "EN",
      status: "0",
      language: "",
      isBanned: "",
      isVerified: "",
      vipUser: "",
      searchKey: "",
      findEvent: "created",
    },
    user: {
      userEmail: "",
      language: "",
      isBanned: "",
      isVerified: "",
      vipUser: "",
      loginType: "",
      userMob: "",
      userName: "",
      name: "",
      city: "",
      country: "",
      facebookId: "",
      imageURL: "",
      isPrivateProfile: "",
      categoryList: "",
      location: { type: "Point", coordinates: [] },
      joinDate: "",
      firstName: "",
      lastName: "",
    },
    displayImage: "",
    event: {
      email: "",
      language: "",
      title: "",
      description: "",
      phone: "",
      name: "",
      city: "",
      talukName: "",
      districtName: "",
      country: "",
      imageURL: "",
      categoryId: "",
      location: { type: "Point", coordinates: [] },
      startTime: "",
      endTime: "",
      usersId: {},
      address: "",
      address2: "",
      attachments: [],
      mobiles: [],
      emails: [],
      users: [],
      isRecurring: false,
      calendarType: "",
      recurringInterval: "",
      tithi: "",
      suryanakshatra: "",
      month: "",
      day: "",
      feature: false,
      alltime: false,
      district: false,
      taluk: false,
      town: false,
    },
    gregorianMonths: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    itemToDelete: "",
    itemToView: "",
    usertoBan: "",
    eventToDelete: "",
  }),

  methods: {
    formatDate(dateString) {
      return moment(dateString).format("DD-MM-YYYY");
    },

    addEvent() {
      this.$data.viewUserPopup = true;
    },

    openDoc(url) {
      window.open(url, "_blank");
    },

    dateSelected(e) {
      this.$data.user.joinDate = e;
    },

    async resetData() {
      this.$data.search = {
        sort: 1,
        // language: "EN",
        status: "0",
        language: "",
        isBanned: "",
        isVerified: "",
        searchKey: "",
      };
      this.$data.searchValue = "";
      await this.fetchAllUsers();
    },

    addNewEvent() {
      this.$data.eventModal = true;
      this.$data.viewUserPopup = false;
      this.$data.newEvent = true;
      this.$data.displayImage = "";
      this.$data.event = {
        email: "",
        language: "",
        title: "",
        description: "",
        phone: "",
        name: "",
        city: "",
        talukName: "",
        districtName: "",
        country: "",
        imageURL: "",
        categoryId: "",
        location: { type: "Point", coordinates: [] },
        startTime: "",
        endTime: "",
        usersId: {},
        attachments: [],
        address: "",
        address2: "",
        mobiles: [],
        emails: [],
        users: [],
        feature: false,
        alltime: false,
        district: false,
        taluk: false,
        town: false,
      };
    },

    onImageChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.event.imageURL = file;
        this.displayImage = URL.createObjectURL(file);
      }
    },

    clearImage() {
      this.displayImage = "";
      this.event.imageURL = "";
      if (this.$refs.fileInput) this.$refs.fileInput.value = null;
    },

    triggerFileInput() {
      if (this.$refs.fileInput) this.$refs.fileInput.click();
    },

    onDropImage(e) {
      const files = e.dataTransfer.files;
      if (files && files[0]) {
        this.onImageChange({ target: { files } });
      }
    },

    getAddressData(data) {
      if (document.getElementById("map")) this.$data.event.address = document.getElementById("map").value;

      if (data.longitude && data.latitude) {
        this.$data.event.location.coordinates = [data.longitude, data.latitude];
        this.$data.event.pincode = data.postal_code ? data.postal_code : "";
        this.$data.event.city = data.locality ? data.locality : data.administrative_area_level_2;
        this.$data.event.state = data.administrative_area_level_1;
      }
    },

    addingNewItem() {
      this.$data.defaultalert = true;
      this.$data.isNew = true;
      this.$data.displayImage = "";
      this.$data.user = {
        userEmail: "",
        language: "",
        isBanned: false,
        vipUser: false,
        isVerified: false,
        loginType: "",
        userMob: "",
        userName: "",
        name: "",
        city: "",
        country: "",
        facebookId: "",
        imageURL: "",
        isPrivateProfile: false,
        categoryList: "",
        firstName: "",
        lastName: "",
        location: { type: "Point", coordinates: [] },
        joinDate: "",
      };
    },

    padTo2Digits(num) {
      return num.toString().padStart(2, "0");
    },

    editingItem(i) {
      this.$data.user = Object.assign({}, i);
      this.$data.defaultalert = true;
      this.$data.isNew = false;
    },

    editingEvent(i) {
      this.$data.event = Object.assign({}, i);
      this.$data.event["imageURL"] = this.$data.event.imageURL ? this.$data.event.imageURL : "";
      if (i.categoryId && i.categoryId._id) this.$data.event["categoryId"] = i.categoryId._id;
      this.$data.eventModal = true;
      this.$data.viewUserPopup = false;
      this.$data.newEvent = false;
      this.$data.displayImage = this.$data.event.imageURL;
    },

    deleteattachmentImage(item) {
      if (item > -1) {
        this.$data.event.attachments.splice(item, 1);
      }
    },

    async btnAddEvent() {
      var usersIds = [];
      if (
        !this.$data.event.endDate ||
        !this.$data.event.startDate ||
        !this.$data.event.title ||
        !this.$data.event.description ||
        !this.$data.event.address ||
        !this.$data.event.endTime ||
        !this.$data.event.startTime ||
        !this.$data.event.categoryId ||
        !this.$data.event.talukName ||
        !this.$data.event.districtName
      ) {
        this.$vs.notify({
          text: "Please enter all the details",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      if (this.$data.event.mobiles && this.$data.event.mobiles.length > 0 && typeof this.$data.event.mobiles == "string")
        this.$data.event.mobiles = this.$data.event.mobiles.split(",");
      if (this.$data.event.emails && typeof this.$data.event.emails === "string") {
        this.$data.event.emails = this.$data.event.emails.split(",");
      }

      if (this.$data.event.users && this.$data.event.users.length > 0) {
        for (var i = 0; i < this.$data.event.users.length; i++) {
          usersIds.push(this.$data.event.users[i]._id);
        }
        this.$data.event.users = usersIds;
      }

      this.$data.event["usersId"] = this.$data.itemToView._id;
      this.$data.event["language"] = this.$data.itemToView.language;

      let date = new Date(this.$data.event.startDate);
      let eDate = new Date(this.$data.event.endDate);

      this.$data.event.location.coordinates[0] = parseFloat(this.$data.event.location.coordinates[0]);
      this.$data.event.location.coordinates[1] = parseFloat(this.$data.event.location.coordinates[1]);

      if (this.$data.event.imageURL && this.$data.event.imageURL instanceof File)
        await this.uploadImage({ target: { files: [this.$data.event.imageURL] } });

      if (this.$data.event.startDate) this.$data.event.startDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
      if (this.$data.event.endDate)
        this.$data.event.endDate = eDate.getFullYear() + "-" + this.padTo2Digits(eDate.getMonth() + 1) + "-" + this.padTo2Digits(eDate.getDate());

      if (!this.$data.newEvent) {
        if (typeof this.$data.event.startTime == "object")
          this.$data.event.startTime = this.$data.event.startTime.hh + ":" + this.$data.event.startTime.mm;
        if (typeof this.$data.event.endTime == "object") this.$data.event.endTime = this.$data.event.endTime.hh + ":" + this.$data.event.endTime.mm;

        await this.btnUpdateEvent();
      } else {
        let data = this.$data.event;

        if (!data.feature) {
          data.alltime = false;
          data.district = false;
          data.taluk = false;
          data.town = false;
        } else {
          if (!data.alltime && !data.district && !data.taluk && !data.town) {
            this.$vs.notify({
              text: "Please select feature type",
              color: "danger",
              position: "top-right",
            });
            return;
          }
        }
        this.$vs.loading();
        try {
          const r = await api.post(API.GET_EVENT, data);
          if (r.status === 200) {
            this.$vs.notify({
              text: "Saved Successfully",
              color: "success",
              position: "top-right",
            });
            this.$data.newEvent = true;
            this.$data.eventModal = false;
            this.$data.viewUserPopup = true;
            await this.fetchAllEvents();
          }
        } catch (error) {
          this.$vs.notify({
            text: error.response.message,
            color: "danger",
            position: "top-right",
          });
          console.error("Error saving event:", error);
        } finally {
          this.$vs.loading.close();
        }
      }
    },

    async uploadImage(data, attachments = false) {
      const imageType = ["image/jpeg", "image/jpg", "image/webp"];
      var isValid = false;
      isValid = imageType.indexOf(data.target.files[0].type) > -1;

      if (!isValid) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "Only JPEG,JPG,WEBP Image files formats should be supported",
          color: "danger",
          position: "top-right",
        });
        this.$refs.fileInput.value = null;
        return;
      }
      if (data.target.files[0].size > 500000) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "File size should be less than 500kb",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      this.$vs.loading();
      try {
        let formdata = new FormData();
        this.$data.fileName = data.target.files[0].name;
        formdata.append("file", data.target.files[0]);

        const response = await api.post(API.UPLOAD_IMAGE, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (response && response.status === 200) {
          if (!attachments) this.$data.event.imageURL = response.data.files[0].url;
          else
            this.$data.event.attachments.push({
              filetype: response.data.files[0].fileType,
              fileurl: response.data.files[0].url,
            });

          this.$vs.notify({
            text: "File Uploaded",
            color: "success",
            position: "top-right",
          });

          this.$refs.fileInput.value = null;
          if (attachments) this.$refs.fileInput2.value = null;
          this.$emit("input", data);
        }
      } catch (error) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "There was an error uploading the file.",
          color: "danger",
          position: "top-right",
        });
        console.error(error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async btnUpdateEvent() {
      try {
        const event = this.$data.event;

        if (
          !event.endDate ||
          !event.startDate ||
          !event.title ||
          !event.description ||
          !event.address ||
          !event.endTime ||
          !event.startTime ||
          !event.categoryId ||
          !event.talukName ||
          !event.districtName
        ) {
          this.$vs.notify({
            text: "Please enter all the details",
            color: "danger",
            position: "top-right",
          });
          return;
        }

        this.$vs.loading();
        const id = event._id;
        const r = await api.put(API.GET_EVENT, event, { params: { id } });

        if (r.status === 200) {
          this.$vs.notify({
            text: "Updated Successfully",
            color: "success",
            position: "top-right",
          });
          this.$data.newEvent = true;
          this.$data.eventModal = false;
          this.$data.viewUserPopup = true;
          await this.fetchAllEvents();
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Failed to update event.",
          color: "danger",
          position: "top-right",
        });
        console.error("Failed to update event:", error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async fileter(event, param, flag = true) {
      this.$data.search[param] = event;
      this.$data.currentPage = 1;
      if (flag) {
        await this.fetchAllUsers(this.$data.currentPage);
      }
    },

    async fetchAllUsers(page) {
      this.$vs.loading();

      try {
        const r = await api.get(API.GET_USERS, {
          params: {
            page: page,
            pageSize: this.$data.pagination ? this.$data.pagination.per_page : 10,
            sort: this.$data.search.sort,
            language: this.$data.search.language,
            isBanned: this.$data.search.isBanned,
            isVerified: this.$data.search.isVerified,
            searchKey: this.$data.search.searchKey,
            searchValue: this.$data.searchValue,
          },
        });

        if (r.status === 200) {
          this.$data.all = r.data.data.data;

          if (r.data.data.meta && r.data.data.meta.pagination) {
            r.data.data.meta.pagination.current_page = parseInt(r.data.data.meta.pagination.current_page);
            this.$data.pagination = r.data.data.meta.pagination;
          }
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Failed to fetch users.",
          color: "danger",
          position: "top-right",
        });
        console.error("Error fetching users:", error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async btnAddUser() {
      let data = this.$data.user;
      let fieldName = "";
      if (data.userEmail == "") {
        fieldName = "User Email";
      }
      if (data.language == "") {
        fieldName = "Language";
      }
      if (data.userEmail == "" || data.language == "") {
        this.$vs.notify({
          text: fieldName + " Require",
          color: "warning",
          position: "top-right",
        });
        return;
      }

      data.location.coordinates[0] = parseFloat(data.location.coordinates[0]).toFixed(6);
      data.location.coordinates[1] = parseFloat(data.location.coordinates[1]).toFixed(6);

      this.$vs.loading();
      try {
        if (!this.$data.isNew) {
          if (this.$data.user.userEmail == "") {
            this.$vs.notify({
              text: "User Email Require",
              color: "warning",
              position: "top-right",
            });
            return;
          }
          if (this.$data.user.language == "") {
            this.$vs.notify({
              text: "Language Require",
              color: "warning",
              position: "top-right",
            });
            return;
          }
          await this.btnUpdateUser();
        } else {
          const r = await api.post(API.ADD_USER, data);

          if (r.status === 200 && r.data.status) {
            this.$vs.notify({
              text: "Saved Successfully",
              color: "success",
              position: "top-right",
            });
            this.$data.isNew = true;
            this.$data.itemToUpdate = "";
            this.$data.defaultalert = false;
            await this.fetchAllUsers(this.$data.currentPage);
          }
        }
      } catch (error) {
        this.$vs.notify({
          text: error.response.data.message,
          color: "danger",
          position: "top-right",
        });
        console.error("Error adding/updating user:", error);
      } finally {
        this.$vs.loading.close();
      }
    },

    // async fetchHinduCalendar(language) {
    //   this.$vs.loading();
    //   try {
    //     const response = await api.get(`${API.FETCH_HINDU_CALENDAR}?data_language=${language}`);
    //     if (response.status === 200) {
    //       this.translatedTithis = response.data.tithis;
    //       this.translatedSuryanakshatras = response.data.suryaNakshatras;
    //     }
    //   } catch (error) {
    //     this.$vs.notify({
    //       title: "Error",
    //       text: "Failed to fetch Hindu calendar data.",
    //       color: "danger",
    //       position: "top-right",
    //     });
    //     console.error("Error fetching Hindu calendar data:", error);
    //   } finally {
    //     this.$vs.loading.close();
    //   }
    // },

    async btnUpdateUser(ban = false) {
      this.$vs.loading();
      const data = ban ? { isBanned: true } : this.$data.user;
      const id = ban ? this.$data.usertoBan._id : this.$data.user._id;

      try {
        const r = await api.put(API.UPDATE_USER, data, { params: { id: id } });

        if (r.status === 200) {
          this.$vs.notify({
            text: "Updated Successfully",
            color: "success",
            position: "top-right",
          });
          this.$data.isNew = true;
          this.$data.itemToUpdate = "";
          this.$data.defaultalert = false;
          this.$data.usertoBan = "";
          this.$data.banUserPopup = false;

          await this.fetchAllUsers(this.$data.currentPage);
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Failed to update user.",
          color: "danger",
          position: "top-right",
        });
        console.error("Failed to update user:", error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async deleteUser() {
      let id = this.$data.itemToDelete._id;
      this.$vs.loading();

      try {
        const r = await api.delete(API.DELETE_USER, { params: { id: id } });

        if (r.status === 200) {
          this.$vs.notify({
            text: "Deleted Successfully",
            color: "success",
            position: "top-right",
          });
        }

        this.$data.deleteUserPopup = false;
        await this.fetchAllUsers(this.$data.currentPage);
      } catch (error) {
        this.$vs.notify({
          text: "Error deleting user",
          color: "danger",
          position: "top-right",
        });
        console.error("Failed to delete user:", error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async fetchAllEvents() {
      this.$data.search.findEvent = "created";
      this.$vs.loading();

      await this.fetchAllCategory(this.$data.itemToView.language);

      try {
        const r = await api.get(API.GET_EVENT, {
          params: {
            searchKey: "usersId",
            searchValue: this.$data.itemToView._id,
            pageSize: 1000,
          },
        });

        if (r.status === 200) this.$data.events = r.data.data.data;
      } catch (error) {
        this.$vs.notify({
          text: "Error fetching events",
          color: "danger",
          position: "top-right",
        });
        console.error("Error fetching events:", error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async findEvent(e) {
      if (e !== "created") {
        this.$vs.loading();
        try {
          const r = await api.post(API.EVENT_PARTICIPANT + "/find", {
            usersId: this.$data.itemToView._id,
            status: e,
          });
          if (r.status === 200) this.$data.events = r.data;
        } catch (error) {
          this.$vs.notify({
            text: "Error fetching event",
            color: "danger",
            position: "top-right",
          });
          console.error("Error fetching events:", error);
        } finally {
          this.$vs.loading.close();
        }
      } else {
        await this.fetchAllEvents();
      }
    },

    async deleteEvent() {
      let id = this.$data.eventToDelete._id;
      try {
        const r = await api.delete(API.GET_EVENT, { params: { id: id } });
        if (r.status == 200) {
          this.$vs.notify({
            text: "Deleted Successfully",
            color: "success",
            position: "top-right",
          });
        }
        this.$data.deleteEventPopup = false;
        this.addEvent();
        await this.fetchAllEvents();
      } catch (error) {
        this.$vs.notify({
          text: "Error deleting event",
          color: "danger",
          position: "top-right",
        });
        console.error("Failed to delete event:", error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async fetchAllCategory() {
      this.$vs.loading();
      try {
        const r = await api.get(API.GET_EVENT_CAT + `?&language=${this.$data.itemToView.language}&status=1`, {});
        if (r.status === 200) this.$data.categories = r.data;
      } catch (error) {
        console.error(error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async invitedUsers() {
      this.$vs.loading();
      try {
        const r = await api.post(API.GET_USERS + "/invitefollowers", {
          userId: this.$data.itemToView._id,
        });

        if (r.status === 200) this.$data.userFollowers = r.data;
      } catch (error) {
        this.$vs.notify({
          text: "Error fetching invited users",
          color: "danger",
          position: "top-right",
        });
        console.error(error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async fetchAllLanguages() {
      this.$vs.loading();
      try {
        const r = await api.get(API.GET_LANG, {});
        this.languages = r.data;
      } catch (error) {
        this.$vs.notify({
          text: "Error fetching languages",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },

  async mounted() {
    await Promise.all([this.fetchAllLanguages(), this.fetchAllUsers(this.$data.currentPage)]);
  },
};
</script>

<style scoped>
.material-icons {
  font-family: "Material Icons";
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  direction: ltr;
  -webkit-font-smoothing: antialiased;
}
</style>
